const selectSelectors = {
    choices: {
        container: "[data-custom-choices]"
    }
};

const selectAttributes = {
    choices: {
        selectPlaceholder: "data-custom-choices-placeholder",
        customProperties: "data-custom-properties"
    }
};

const selectModifiers = {
    initialized: "initialized"
};
function initSelects() {
    let $choices = $(selectSelectors.choices.container);

    initialize($choices, initCustomChoices);

    function initCustomChoices() {
        let select = this;
        let placeholderValue = $(select).attr(
            selectAttributes.choices.selectPlaceholder
        );

        let options = {
            searchEnabled: false,
            shouldSort: false,
            allowHTML: true,
            classNames: {
                containerOuter: 'choices select__desktop'
            },
        };

        if (placeholderValue) {
            options.placeholder = true;
            options.placeholderValue = placeholderValue;
        }

        new Choices(select, options);
    }
}

function initialize(containers, callback) {
    Array.from(containers)
        .filter(function (element) {
            return !element.classList.contains(selectModifiers.initialized);
        })
        .forEach(function (element) {
            callback.call(element);

            element.classList.add(selectModifiers.initialized);
        });
}
document.addEventListener("DOMContentLoaded", initSelects);
document.addEventListener("select:init", initSelects);

const customSelectList = document.querySelectorAll(".custom-select");
const customSelectArray = [...customSelectList];

customSelectArray.forEach(selectBlock => {
    let selectBlockDesktop = selectBlock.querySelector('.js-select-desktop');
    let selectBlockMobile = selectBlock.querySelector('.js-select-mobile');
    if (!selectBlockDesktop) return;
    selectBlockDesktop.addEventListener('change', function () {
        if (selectBlockMobile.value != this.value) {
            selectBlockMobile.value = this.value;
        }
    });
});